<template>
    <b-popover @shown="onShow" :target="target" triggers="click blur" :show.sync="popoverShow" placement="bottom">
        <div class="row">
            <div class="col">
                <button v-if="selected.length>0" class="btn btn-outline-secondary btn-sm" @click="clear">{{$t('Clear')}}</button>
            </div>
            <div class="col-auto">
                <custom-switch v-model="kid" :title="$t('Baby map') " id="kidOrNot1" class="m-0 p-0" />
            </div>
        </div>
        <image-map :kid="kid" :selectable="true" :value="selected" @input="emit" :width="15" :tooths="{}"></image-map>
    </b-popover>
</template>

<script>
import debounce from 'lodash/debounce';
import ImageMap from '@/components/Teeth/Map';
import CustomSwitch from '@/components/CustomSwitch';
export default {
    props: ['target', 'exam', 'action', 'value', 'isKid'],
    components: {
        ImageMap,
        CustomSwitch

    },
    data() {
        return {
            markAsDone: true,
            kid: false,
            data: [],
            selected: [],
            popoverShow: false,
        }
    },
    watch: {
        value(newVal) {
            this.selected = newVal;
        }
    },

    methods: {
        clear() {
            this.emit([])
        },

        emit(value) {
            this.$emit('input', value)
        },

        duplicate() {
            let items = this.$unique(this.selected);

            this.$root.$emit('bv::hide::popover');
            this.$toasted.global.success({
                message: this.$t('Item has been saved')
            });

        },
        onShow() {
            if (!this.value) return
            this.selected = this.$copy(this.value);
            this.kid = this.isKid;
            // this.$root.$emit('bv::hide::popover');
        },

    }
}
</script>
<style scoped>
    .popover{
        min-width:650px;
    }
    @media only screen and (max-width: 576px) {
        .popover{
            min-width: 97%!important;
        }
    }
</style>
